module.exports = __webpack_public_path__ + "img/top-border-cards.45f1a584.png";